export default {"src":"/_next/static/media/data_room.f897b8a4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};